const KEY = "gf_utm";

export const captureUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const u = {};
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = p.get(k);
      if (v) u[k] = v.slice(0, 120);
    });
    if (Object.keys(u).length) sessionStorage.setItem(KEY, JSON.stringify(u));
  } catch { /* ignore */ }
};

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; }
};
